import { useTranslation } from 'react-i18next';
import PageTemplate from '../../components/PageTemplate/PageTemplate';
import Home from '../../modals/components/Home/Home';

export default function HomePage() {
  const { t } = useTranslation();
  return <PageTemplate title={t('home.title')} content={<Home />} />;
}
